import { getBreakpoint } from './breakpoint'
import { reactive } from 'vue'

const store = reactive({
    breakpoint: getBreakpoint(),
    // the property page's search party { adults, children }, shared by both availability calendars
    guests: null,
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
})

export default store
